import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../constants/Config';
import {
  GET_EQUIPMENTS_LIST,
  GET_EQUIPMENTS_LIST_SUCCESS,
  GET_EQUIPMENTS_LIST_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/equipment';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.equipment;
const equipment = (state = initialSettings, action) => {
  switch (action.type) {
    // LIST EQUIPMENTS
    case GET_EQUIPMENTS_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case GET_EQUIPMENTS_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.data),
            pageNumber: _parseInt(action.data.page_number),
            pageSize: _parseInt(action.data.page_size),
            totalEntries: _parseInt(action.data.total_entries),
            totalPages: _parseInt(action.data.total_pages),
          },
        },
      };
    case GET_EQUIPMENTS_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
};

export default equipment;



// WEBPACK FOOTER //
// ./reducers/equipment/equipment.js